import React from 'react';
import ReactDOM from 'react-dom/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ErrorBoundary } from './components/ErrorBoundary';
import { AppConfigProvider } from './contexts/AppConfigContext';
import App from './App';
import './index.css';
import 'maplibre-gl/dist/maplibre-gl.css';
import { fetchAppConfig } from './config';

const queryClient = new QueryClient();

async function bootstrap() {
  const buildTimeClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID || '';
  let config = { googleClientId: buildTimeClientId };
  if (!buildTimeClientId) {
    try {
      config = await fetchAppConfig();
    } catch {
      config = { googleClientId: '' };
    }
  }

  const AppWithProviders = () => (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AppConfigProvider config={config}>
          {config.googleClientId ? (
            <GoogleOAuthProvider clientId={config.googleClientId}>
              <App />
            </GoogleOAuthProvider>
          ) : (
            <App />
          )}
        </AppConfigProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <AppWithProviders />
    </React.StrictMode>,
  );
}

bootstrap();
